// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"73af6e7f","592":"74f6dd37","787":"533111d1","965":"3c80a2e2"}[chunkId] + ".chunk.js";
};